import { mergeClassnames } from '@heathmont/moon-core-tw';
import getRtpState from '../shared/helpers/getRtpState';
import getRtpStateBackground from '../shared/helpers/getRtpStateBackground';
import RtpArrow from '../shared/RtpArrow';

const GameCardRtpBadges: FC<LiveRtpBadgesProps> = ({ game, rtpField }) => {
  const rtp = game.rtp;
  const rtpLive = game[rtpField];
  if (!rtpLive) {
    return null;
  }
  const state = getRtpState(rtp ?? 0, rtpLive);
  const color = getRtpStateBackground(state);
  return (
    <div className="inline-container gap-2">
      <div
        className={mergeClassnames(
          'grid grid-flow-col items-center gap-1 rounded-moon-s-sm px-2 py-0.5 text-moon-12 font-semibold text-goten',
          color,
        )}
      >
        <span>{rtpLive}%</span>
        <RtpArrow state={state} />
      </div>
      {rtp && <p className="text-moon-12 font-semibold text-trunks">{rtp}%</p>}
    </div>
  );
};

export default GameCardRtpBadges;
